import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
// import useMediaQuery from '@mui/material/useMediaQuery';

import { fetch_one, fetch_all } from "../../../lib/v31lib";
import { loginAtom } from '../../../lib/auth';

import Lenis from "lenis";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { gsap } from "gsap";
import { DropzoneArea } from 'mui-file-dropzone';

import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import QrCodeIcon from '@mui/icons-material/QrCode';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';

import {
  Box,
  Checkbox,
  CircularProgress,
  Divider,
  FormControlLabel,
  Grid,
  MenuItem,
} from '@mui/material';
import {
  ProfileBox,
  WhiteSection
} from '../../../components/v2/custom';
import {
  DarkGreenButton,
  Dt,
  IconButton,
  LightGreenButton,
  Page,
  Select,
  ShareShower,
  TextButton,
  TextInput,
  TransparentButton,
  Typography
} from '../../../components/v2/styled';
import { Birthdate } from '../../../components/v2/styled/Birthdate';
import { ZichtAccount } from '../../../components/v2/styled/ZichtAccount';
import { WideButton } from '../../../components/v2/styled/WideButton';
import { Vennr } from '../../../components/v2/styled/Vennr';
import { OtpCode } from '../../../components/v2/styled/OtpCode';

import { Guardian } from '../../../models/Guardian';
import { User } from '../../../models/User';
import { ErrorBox } from '../../../components/v2/styled/ErrorBox';

var he = require('he');
const { DateTime } = require("luxon");

type Props = {}

export const ExitIndex: FunctionComponent<Props> = ({}) => {
  const [login, setLogin] = useAtom(loginAtom);
  const theme = useTheme();
  const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);

  let canDoExit = DateTime.now().month >= 7;
  if (window.location.host.indexOf('localhost') > -1 || window.location.host.indexOf('staging.') > -1) {
    canDoExit = true;
  }

  const [paperTrailFields, setPaperTrailFields] = useState<boolean>(false);
  const [startExit, setStartExit] = useState<boolean>(false);
  const [selectedReasons, setSelectedReasons] = useState<number[]>([]);
  const [otherReason, setOtherReason] = useState<string>('');
  const [userData, setUserData] = useState<User>({
    auth_token: '',
    email: ''
  });
  const [showError, setShowError] = useState<boolean>(false);
  const [dataIsCorrect, setDataIsCorrect] = useState<boolean>(false);
  const [zichtAccountOkay, setZichtAccountOkay] = useState<boolean>(false);
  const [changingAmount, setChangingAmount] = useState<boolean>(false);
  const [exitAmount, setExitAmount] = useState<number>(0);
  const [files, setFiles] = useState<{item: File|undefined, identity: File|undefined}>({item: undefined, identity: undefined});

  const [activeUserId, setActiveUserId] = useState<number>();
  const [vennr, setVennr] = useState<string>('');
  const [birthdate, setBirthdate] = useState<string>('');
  const [otp, setOtp] = useState<string>('');
  const [showOtp, setShowOtp] = useState<boolean>(false);
  

  const queryClient = useQueryClient();

  const {
    data: exitReasons,
    isLoading: exitReasonsLoading,
    // isError: adviceUploadsError,
    isSuccess: exitReasonsSuccess,
    // refetch: adviceUploadsRefetch,
  } = useQuery({
    queryKey: ["nw", "exit_reasons"],
    queryFn: () =>
      fetch_all<{id: number; name:  {[z:string]: string};}>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/pub/fetch_all`,
        {
          object: 'exit_reason',
          fields: ['id', 'name', 'is_hidden'],
          per_page: 1000,
          page: 0,
          order: 'weight ASC',
          filter: {
            advanced: {
              is_hidden: 0
            }
          }
        }
      )
  });
  const {
    data: tempUser,
    // isLoading: fullBenefitLoading,
    // isError: adviceUploadsError,
    isSuccess: tempUserSuccess,
    refetch: tempUserRefetch,
  } = useQuery({
    queryKey: ["nw", "user", 'data', login?.id],
    queryFn: () =>
      fetch_one<User>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/pub/fetch_all`,
        {
          object: 'user',
          fields: [
            'id', 'username', 'first_name', 'last_name', 'birth_date', 'email', 'phone', 'mobile', 'zicht_account',
            'street', 'number', 'zip', 'city', 'exit_information', 'share_type|id/tag', 'vennoot_number', 'stock_number'
          ],
          id: activeUserId,
          use_ob: 1
        }
      ),
    enabled: !!activeUserId,
  });







  const mutationCustomAction = useMutation({
    mutationFn: (pars: {
      formData: any;
      mode?: string;
    }) => {
      return fetch_one<{
        custom_result: any
      }>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/pub/custom_action`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      setShowOtp(false);

      if (variables.mode === 'authenticate') {
        if (!!data.custom_result.mfa_status_0_verification) {
          setShowOtp(true);
        } else {
          if (!data.custom_result.exists) {
            setShowError(true);
          } else {
            setActiveUserId(data.custom_result.id);
          }
        }
      }

      if (variables.mode === 'start_paper') {
        tempUserRefetch();
      }
      if (variables.mode === 'upload_docs') {
        tempUserRefetch();
      }
      if (variables.mode === 'start_digital') {
        window.location = data.custom_result
      }
      
      window.scrollTo(0, 0);
    },
  });








  const emailCheck = (email:string) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }

  const tableRow = (label: string, content: string|undefined, children: any, divider: boolean, copyable?: boolean, lessPadding?: boolean) => {
    return <>
      <Grid item xs={5} sx={{
        paddingTop: !lessPadding ? {
          xs: 1,
          md: 2,
          lg: 3
        } : 0,
        paddingBottom: !lessPadding ? {
          xs: 1,
          md: 2,
          lg: 3
        } : 0,
        paddingLeft: {
          xs: 1,
          md: 2,
          lg: 3
        }
      }}>
        <Typography sx={{
          textTransform: 'uppercase',
          color: theme.palette.primary.light
        }}>{label}</Typography>
      </Grid>
      <Grid item xs={7} sx={{
        paddingTop: !lessPadding ? {
          xs: 1,
          md: 2,
          lg: 3
        } : 0,
        paddingBottom: !lessPadding ? {
          xs: 1,
          md: 2,
          lg: 3
        } : 0,
        paddingRight: {
          xs: 1,
          md: 2,
          lg: 3
        },
        position: 'relative'
      }}>
        {!!content && <Typography variant="body1" html fuck_p_tags>{content}</Typography>}
        {!!children && children}
        {!!copyable && <IconButton
          color="primary"
          sx={{
            position: 'absolute',
            top: {
              xs: !!lessPadding ? -8 : -4,
              md: !!lessPadding ? -8 : 12
            },
            right: 8
          }}
          title={he.decode(t("nw.emission.steps.stock.order_detail.cta_hint.copy").replace(/<[^>]*>?/gm, ''))}
          onClick={(e) => {
            e.preventDefault();
            navigator.clipboard.writeText(he.decode((content || '').replace(/<[^>]*>?/gm, '')));
          }}
        >
          <ContentCopyIcon />
        </IconButton>}
      </Grid>

      {!!divider && <Grid item xs={12}>
        <Divider />
      </Grid>}
    </>;
  }
  
  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    const lenis = new Lenis({
      // duration: 2,
    });
    lenis.on("scroll", ScrollTrigger.update);

    gsap.ticker.add((time) => {
      lenis.raf(time * 1000);
    });

    gsap.ticker.lagSmoothing(0);
  }, []);
  useEffect(() => {
    setUserData({
      auth_token: '',
      first_name: tempUser?.first_name,
      last_name: tempUser?.last_name,
      email: tempUser?.email || '',
      phone: tempUser?.phone,
      mobile: tempUser?.mobile,
      street: tempUser?.street,
      number: tempUser?.number,
      zip: tempUser?.zip,
      city: tempUser?.city,
      zicht_account: tempUser?.zicht_account,
    });
    setExitAmount(tempUser?.stock_number || 0);
  }, [tempUser]);
  useEffect(() => {
    if (!!login?.id) setActiveUserId(login?.id);
  }, [login]);

  return <Page>
    <WhiteSection isTransparent sx={{
      "& > div > div": {
        padding: 0
      },
      "& > div > div > div > div": {
        minHeight: 20,
        height:'auto'
      }
    }}>
      <Grid container spacing={0} sx={{
        width: {
          xs: '100%',
          lg: '900px'
        },
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: 8,
        marginBottom: 8
      }}>
        <Grid item xs={12} sx={{
          marginBottom: 2.5
        }}>
          <Typography variant="h3">{t("nw.exit.title")}</Typography>
        </Grid>
        {!canDoExit && <>
          <Grid item xs={12} sx={{
            marginBottom: 2.5
          }}>
            <Typography variant="subtitle1">{t("nw.exit.period_closed.message")}</Typography>
          </Grid>
          <Grid item xs={12} sx={{
            marginBottom: 2.5,
            marginTop: 2.5
          }}>
            <ErrorBox
              type="success"
              title={t("nw.exit.transfer_cta.title")}
              content={<>
                <Typography html fuck_p_tags>{t("nw.exit.transfer_cta.content")}</Typography>
                <DarkGreenButton
                  label={t("nw.exit.transfer_cta.cta")}
                  id="transfer_btn"
                  sx={{
                    marginTop: 3,
                    marginBottom: 2
                  }}
                  onClick={() => {
                    navigate('/stock/transfer');
                  }}
                />
              </>}
              icon={<TipsAndUpdatesIcon sx={{
                width: '60px',
                height: '60px'
              }} />}
              sx={{
                maxWidth: {
                  xs: '100%',
                },
              }}
            />
          </Grid>
        </>}
        {!!canDoExit && <>
          {!login && !tempUserSuccess && <>
            <Grid item xs={12} sx={{
              marginBottom: 2.5
            }}>
              <Typography variant="subtitle1">{t("nw.exit.need_to_be_logged_in.message")}</Typography>
            </Grid>
            <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4}}>
              <Box sx={{
                display: 'inline-block',
                width: {
                  xs: '100%',
                  lg: '440px'
                },
                textAlign: 'left'
              }}>
                <Vennr
                  value={vennr || ''}
                  onChange={(v) => {
                    setVennr(v.target.value);
                  }}
                  starred
                  caption={t("nw.register.form.lidnummer")}
                  // placeholder={t("nw.contact.form.placeholder.first_name")}
                  sx={{
                    borderRadius: "8px",
                    width: '100%',
                    border: "2px solid transparent",
                    borderColor: theme.palette.primary.dark,
                    paddingTop: 0.25,
                    paddingBottom: 0.25,
                    height: '40px',
                    backgroundColor: 'transparent',
                  }}
                />
                <Birthdate
                  value={birthdate || ''}
                  onChange={(v) => {
                    setBirthdate(v.target.value);
                  }}
                  starred
                  hideError
                  caption={t("nw.user_info.birth_date")}
                  // placeholder={t("nw.contact.form.placeholder.first_name")}
                  sx={{
                    borderRadius: "8px",
                    width: '100%',
                    border: "2px solid transparent",
                    borderColor: theme.palette.primary.dark,
                    paddingTop: 0.25,
                    paddingBottom: 0.25,
                    height: '40px',
                    backgroundColor: 'transparent',
                  }}
                />
                {!!showOtp && <OtpCode
                  value={otp || ''}
                  onChange={(v) => {
                    setOtp(v.target.value);
                  }}
                  starred
                  caption={t("nw.public.otp_code")}
                  // placeholder={t("nw.contact.form.placeholder.first_name")}
                  sx={{
                    borderRadius: "8px",
                    width: '100%',
                    border: "2px solid transparent",
                    borderColor: theme.palette.primary.dark,
                    paddingTop: 0.25,
                    paddingBottom: 0.25,
                    height: '40px',
                    backgroundColor: 'transparent',
                  }}
                />}
              </Box>
            </Grid>
            <Grid item xs={12} sx={{
              marginBottom: 2.5
            }}>
              <Box sx={{
                display: 'block',
                width: '100%',
                maxWidth: {
                  xs: '100%',
                  lg: '440px'
                },
                marginTop: 2,
                marginRight: 'auto',
                marginLeft: 'auto',
                textAlign: 'right'
              }}>
                <DarkGreenButton
                  label={t("nw.exit.btn.to_login")}
                  id="sub_btn"
                  sx={{

                  }}
                  onClick={() => {
                    setShowError(false);
                    mutationCustomAction.mutate({
                      formData: {
                        object: 'user',
                        class_action: 'custom_api_validate',
                        birthdate: birthdate,
                        vennr: vennr,
                        otp: otp.replace(" ", "").replace("_", "")
                      },
                      mode: 'authenticate'
                    });
                  }}
                />
              </Box>
            </Grid>
            {!!showError && <Grid item xs={12} sx={{
              marginBottom: 2.5
            }}>
              <ErrorBox
                type="error"
                text={t("nw.contact.form.fail")}
              />
            </Grid>}
          </>}
          {!!tempUserSuccess && <>
            <Grid item xs={12} sx={{
              marginBottom: 2.5
            }}>
              <Box
                sx={{
                  width: {
                    xs: '100%',
                    md: '100%',
                    lg: '670px'
                  },
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  marginBottom: 4,
                  backgroundColor: 'white'
                }}
              >
                <Grid container spacing={0}>
                  {tableRow(
                    t("nw.exit.detail.active_procedure"), 
                    undefined, 
                    !!tempUser.exit_information?.active_exit ? <Typography sx={{fontWeight: 'bold'}}>{t("nw.exit.detail.procedure_is_active")}</Typography> : <Typography sx={{fontWeight: 'bold'}}>{t("nw.exit.detail.procedure_is_not_active")}</Typography>, 
                    true
                  )}

                  {tableRow(
                    t("nw.exit.detail.full_name"), 
                    [tempUser.first_name, tempUser.last_name, ['(', tempUser.vennoot_number, ')'].join('')].join(" "), 
                    undefined, 
                    true
                  )}

                  {!!tempUser.exit_information?.guardian_name && tableRow(
                    t("nw.exit.detail.guardian_full_name"), 
                    tempUser.exit_information?.guardian_name, 
                    undefined, 
                    true
                  )}

                  {tempUser?.exit_information?.amount && tableRow(
                    t("nw.exit.detail.amount"), 
                    undefined, 
                    <ShareShower sx={{fontWeight: {xs: 'bold', md: 'normal'}}} amount={tempUser?.exit_information?.amount || tempUser.stock_number} share={tempUser.share_type_tag as 'A' | 'B'} />, 
                    true
                  )}
                </Grid>
              </Box>
            </Grid>

            {!tempUser.exit_information?.active_exit && <>
              {!startExit && <>
                <Grid item xs={12} sx={{
                  marginBottom: 5
                }}>
                  <ErrorBox
                    type="success"
                    title={t("nw.exit.transfer_cta.title")}
                    content={<>
                      <Typography html fuck_p_tags>{t("nw.exit.transfer_cta.content")}</Typography>
                      <DarkGreenButton
                        label={t("nw.exit.transfer_cta.cta")}
                        id="transfer_btn"
                        sx={{
                          marginTop: 3,
                          marginBottom: 2
                        }}
                        onClick={() => {
                          navigate('/stock/transfer');
                        }}
                      />
                      <Typography html fuck_p_tags>{t("nw.exit.transfer_cta.content2")}</Typography>
                    </>}
                    icon={<TipsAndUpdatesIcon sx={{
                      width: '60px',
                      height: '60px'
                    }} />}
                    sx={{
                      maxWidth: {
                        xs: '100%',
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sx={{
                  marginBottom: 2.5
                }}>
                  <Typography variant="subtitle1">{t("nw.exit.start_procedure_message")}</Typography>
                </Grid>
                <Grid item xs={12} sx={{
                  marginBottom: 2.5
                }}>
                  <DarkGreenButton
                    label={t("nw.exit.btn.start_procedure")}
                    id="start_btn"
                    sx={{
                      margin: 1,
                      marginLeft: {
                        xs: 1,
                        md: 0
                      }
                    }}
                    onClick={() => {
                      setStartExit(true);
                    }}
                  />
                  <TransparentButton
                    label={t("nw.exit.btn.back_to_profile")}
                    id="profile_btn"
                    sx={{
                      margin: 1
                    }}
                    path="/profile"
                  />
                </Grid>
              </>}
              {!!startExit && <>
                {/* keuze van bevestigen + vraag waarom vertrek */}
                <Grid item xs={12} sx={{
                  marginBottom: 2.5
                }}>
                  <Typography variant="subtitle1" html sx={{
                    ...(selectedReasons.length < 1 && !otherReason ? {
                      color: 'red'
                    } : {})
                  }}>{t("nw.exit.detail.feedback_title")}</Typography>
                </Grid>
                {!!exitReasonsSuccess && exitReasons.map(reason => <Grid item xs={12}>
                  <FormControlLabel control={<Checkbox
                    checked={selectedReasons.indexOf(reason.id) > -1}
                    onChange={(e) => {
                      if (!!e.target.checked) {
                        setSelectedReasons([...selectedReasons, reason.id]);
                      } else {
                        setSelectedReasons(selectedReasons.filter(fff => fff !== reason.id));
                      }
                    }}
                  />} label={reason.name[i18n.resolvedLanguage || 'nl']} />
                </Grid>)}
                <Grid item xs={12} sx={{
                  marginBottom: 2.5
                }}>
                  <FormControlLabel control={<Checkbox
                    checked={otherReason.length > 0}
                    onChange={(e) => {
                      if (!!e.target.checked) {
                        setOtherReason(' ');
                      } else {
                        setOtherReason('');
                      }
                    }}
                  />} label={t("nw.exit.reasons.other").replace(/<[^>]*>?/gm, '')} />
                  <TextInput
                    value={otherReason || ''}
                    multiline
                    onChange={(v) => {
                      setOtherReason(v);
                    }}
                    // caption={secQuestion1}
                    noCaption
                    sx={{
                      borderRadius: "8px",
                      width: '100%',
                      border: "2px solid transparent",
                      borderColor: theme.palette.primary.dark,
                      paddingTop: 0.25,
                      paddingBottom: 0.25,
                      backgroundColor: 'transparent',
                      marginTop: 0
                    }}
                  />
                </Grid>
                <Grid item xs={12} sx={{
                  marginBottom: 6.5
                }}>
                  <Typography variant="subtitle1" sx={{marginTop: 4, marginBottom: -1}}>{t("nw.exit.detail.partial_exit_title")}</Typography>
                  <TextInput
                    value={exitAmount.toString() || ''}
                    disabled={!changingAmount}
                    onChange={(v) => {
                      let sn = parseInt(v.toString().replace(/[^0-9]/, ''), 10) || 0;

                      if (sn < 0) sn = tempUser.stock_number || 0;
                      if (sn > (tempUser.stock_number || 0)) sn = tempUser.stock_number || 0;

                      setExitAmount(sn);
                    }}
                    noCaption
                    sx={{
                      borderRadius: "8px",
                      width: {
                        xs: '100%',
                        md: '50%'
                      },
                      border: "2px solid transparent",
                      borderColor: theme.palette.primary.dark,
                      paddingTop: 0.25,
                      paddingBottom: 0.25,
                      height: '40px',
                      backgroundColor: 'transparent',
                    }}
                  />
                  {!changingAmount && <TransparentButton
                    label={t("nw.exit.btn.partial_exit")}
                    id="profile_btn"
                    sx={{
                      marginLeft: {
                        xs: 0,
                        md: 1
                      },
                      marginTop: {
                        xs: 1,
                        md: -0.5
                      },
                      width: {
                        xs: '100%',
                        md: 'auto'
                      }
                    }}
                    onClick={() => {
                      setChangingAmount(true);
                    }}
                  />}
                </Grid>
                {!tempUser.exit_information?.guardian && <Grid item xs={12} md={6} sx={{paddingRight: {xs: 0, md: 1}}}>
                  <WideButton
                    disabled={((otherReason.length < 1 && selectedReasons.length < 1) || exitAmount < 1) || paperTrailFields}
                    label={t("nw.exit.detail.start_trail.itsme")}
                    id="exit_itsme"
                    itsme
                    onClick={() => {
                      if (!(((otherReason.length < 1 && selectedReasons.length < 1) || exitAmount < 1) || paperTrailFields)) {
                        mutationCustomAction.mutate({
                          formData: {
                            object: 'user',
                            class_action: 'custom_api_exit_process',
                            id: tempUser?.id,
                            mode: 'start_digital',
                            amount: exitAmount,
                            reasons: [...selectedReasons, (!!otherReason ? 0 : -1)].filter(fff => fff >= 0).join(","),
                            other_reason: otherReason
                          },
                          mode: 'start_digital'
                        });
                      }
                    }}
                    sx={{
                      opacity: !paperTrailFields ? 1 : 0.3
                    }}
                  />
                </Grid>}
                <Grid item xs={12} md={6} sx={{paddingLeft: {xs: 0, md: !tempUser.exit_information?.guardian ? 1 : 0}, marginTop: {xs: 1, md: 0}}}>
                  <WideButton
                    disabled={(otherReason.length < 1 && selectedReasons.length < 1) || exitAmount < 1}
                    label={t("nw.exit.detail.start_trail.paper")}
                    id="exit_paper"
                    print
                    onClick={() => {
                      if (!((otherReason.length < 1 && selectedReasons.length < 1) || exitAmount < 1)) {
                        if (paperTrailFields) {
                          setPaperTrailFields(false);
                        } else {
                          setPaperTrailFields(true);
                        }
                        setTimeout(() => {window.scrollBy(0, 200);}, 1000);
                      } else {
                        window.scrollTo(0, 0);
                      }
                    }}
                  />
                </Grid>
                {!!paperTrailFields && <>
                  <Grid item xs={12} sx={{
                    marginBottom: 1,
                    marginTop: 6.5
                  }}>
                    <Typography variant="subtitle1">{t("nw.exit.detail.correct_user_data")}</Typography>
                  </Grid>
                  <Grid item xs={12} md={6} sx={{paddingRight: {
                    xs: 0,
                    md: 0.5
                  }}}>
                    <TextInput
                      value={userData?.first_name || ''}
                      onChange={(v) => {
                        setUserData({
                          ...(userData || {
                            auth_token: '',
                            email: ''
                          }),
                          first_name: v.toString()
                        });
                      }}
                      caption={t("nw.user_info.first_name")}
                      sx={{
                        borderRadius: "8px",
                        width: '100%',
                        border: "2px solid transparent",
                        borderColor: theme.palette.primary.dark,
                        paddingTop: 0.25,
                        paddingBottom: 0.25,
                        height: '40px',
                        backgroundColor: 'transparent',
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} sx={{paddingLeft: {
                    xs: 0,
                    md: 0.5
                  }}}>
                    <TextInput
                      value={userData?.last_name || ''}
                      onChange={(v) => {
                        setUserData({
                          ...(userData || {
                            auth_token: '',
                            email: ''
                          }),
                          last_name: v.toString()
                        });
                      }}
                      caption={t("nw.user_info.last_name")}
                      sx={{
                        borderRadius: "8px",
                        width: '100%',
                        border: "2px solid transparent",
                        borderColor: theme.palette.primary.dark,
                        paddingTop: 0.25,
                        paddingBottom: 0.25,
                        height: '40px',
                        backgroundColor: 'transparent',
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} sx={{paddingRight: {
                    xs: 0,
                    md: 0.5
                  }}}>
                    <TextInput
                      value={userData?.email || ''}
                      onChange={(v) => {
                        setUserData({
                          ...(userData || {
                            auth_token: '',
                            email: ''
                          }),
                          email: v.toString()
                        });
                      }}
                      caption={t("nw.user_info.email")}
                      sx={{
                        borderRadius: "8px",
                        width: '100%',
                        border: "2px solid transparent",
                        borderColor: theme.palette.primary.dark,
                        paddingTop: 0.25,
                        paddingBottom: 0.25,
                        height: '40px',
                        backgroundColor: 'transparent',
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} sx={{paddingLeft: {
                    xs: 0,
                    md: 0.5
                  }}}>
                    <TextInput
                      value={userData?.mobile || ''}
                      onChange={(v) => {
                        setUserData({
                          ...(userData || {
                            auth_token: '',
                            email: ''
                          }),
                          mobile: v.toString()
                        });
                      }}
                      caption={t("nw.user_info.mobile")}
                      sx={{
                        borderRadius: "8px",
                        width: '100%',
                        border: "2px solid transparent",
                        borderColor: theme.palette.primary.dark,
                        paddingTop: 0.25,
                        paddingBottom: 0.25,
                        height: '40px',
                        backgroundColor: 'transparent',
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={8} sx={{paddingRight: {
                    xs: 0,
                    md: 0.5
                  }}}>
                    <TextInput
                      value={userData?.street || ''}
                      onChange={(v) => {
                        setUserData({
                          ...(userData || {
                            auth_token: '',
                            email: ''
                          }),
                          street: v.toString()
                        });
                      }}
                      caption={t("nw.user_info.street")}
                      sx={{
                        borderRadius: "8px",
                        width: '100%',
                        border: "2px solid transparent",
                        borderColor: theme.palette.primary.dark,
                        paddingTop: 0.25,
                        paddingBottom: 0.25,
                        height: '40px',
                        backgroundColor: 'transparent',
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4} sx={{paddingLeft: {
                    xs: 0,
                    md: 0.5
                  }}}>
                    <TextInput
                      value={userData?.number || ''}
                      onChange={(v) => {
                        setUserData({
                          ...(userData || {
                            auth_token: '',
                            email: ''
                          }),
                          number: v.toString()
                        });
                      }}
                      caption={t("nw.user_info.number")}
                      sx={{
                        borderRadius: "8px",
                        width: '100%',
                        border: "2px solid transparent",
                        borderColor: theme.palette.primary.dark,
                        paddingTop: 0.25,
                        paddingBottom: 0.25,
                        height: '40px',
                        backgroundColor: 'transparent',
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4} sx={{paddingRight: {
                    xs: 0,
                    md: 0.5
                  }}}>
                    <TextInput
                      value={userData?.zip || ''}
                      onChange={(v) => {
                        setUserData({
                          ...(userData || {
                            auth_token: '',
                            email: ''
                          }),
                          zip: v.toString()
                        });
                      }}
                      caption={t("nw.user_info.zip")}
                      sx={{
                        borderRadius: "8px",
                        width: '100%',
                        border: "2px solid transparent",
                        borderColor: theme.palette.primary.dark,
                        paddingTop: 0.25,
                        paddingBottom: 0.25,
                        height: '40px',
                        backgroundColor: 'transparent',
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={8} sx={{paddingLeft: {
                    xs: 0,
                    md: 0.5
                  }}}>
                    <TextInput
                      value={userData?.city || ''}
                      onChange={(v) => {
                        setUserData({
                          ...(userData || {
                            auth_token: '',
                            email: ''
                          }),
                          city: v.toString()
                        });
                      }}
                      starred
                      caption={t("nw.user_info.city")}
                      sx={{
                        borderRadius: "8px",
                        width: '100%',
                        border: "2px solid transparent",
                        borderColor: theme.palette.primary.dark,
                        paddingTop: 0.25,
                        paddingBottom: 0.25,
                        height: '40px',
                        backgroundColor: 'transparent',
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <ZichtAccount
                      value={userData?.zicht_account || ''}
                      onChange={(v) => {
                        setUserData({
                          ...(userData || {
                            auth_token: '',
                            email: ''
                          }),
                          zicht_account: v.target.value
                        });
                      }}
                      setExternalIsOkay={setZichtAccountOkay}
                      caption={t("nw.user_info.zicht_account")}
                      sx={{
                        borderRadius: "8px",
                        width: '100%',
                        border: "2px solid transparent",
                        borderColor: theme.palette.primary.dark,
                        paddingTop: 0.25,
                        paddingBottom: 0.25,
                        height: '40px',
                        backgroundColor: 'transparent',
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormControlLabel control={<Checkbox
                      checked={!!dataIsCorrect}
                      onChange={(e) => {
                        setDataIsCorrect(!!e.target.checked);
                      }}
                    />} label={t("nw.exit.detail.data_is_correct").replace(/<[^>]*>?/gm, '')} />
                  </Grid>
                  <Grid item xs={12}>
                    <DarkGreenButton
                      label={t("nw.exit.btn.start_procedure_for_real_now")}
                      disabled={!!mutationCustomAction.isPending || !dataIsCorrect || (!userData.first_name || !userData.last_name || !userData.email || !userData.street || !userData.number || !userData.zip || !userData.city || !userData.zicht_account || !zichtAccountOkay)}
                      id="start_real_btn"
                      sx={{
                        margin: 1,
                        marginLeft: {
                          xs: 1,
                          md: 0
                        }
                      }}
                      onClick={() => {
                        mutationCustomAction.mutate({
                        formData: {
                          object: 'user',
                          class_action: 'custom_api_exit_process',
                          id: tempUser?.id,
                          mode: 'start_paper',
                          amount: exitAmount,
                          user: {
                            ...userData
                          },
                          reasons: [...selectedReasons, (!!otherReason ? 0 : -1)].filter(fff => fff >= 0).join(","),
                          other_reason: otherReason
                        },
                        mode: 'start_paper'
                        });
                      }}
                    />
                  </Grid>
                </>}
              </>}
            </>}
            {!!tempUser.exit_information?.active_exit && <>
              {!!tempUser.exit_information?.verified && <>
                {/* dit mag je niet kunnen zien */}
              </>}
              {!tempUser.exit_information?.verified && <>
                {!!tempUser.exit_information?.itsme && <>
                  <Grid item xs={12} sx={{marginTop: 4, position: 'relative',
                    marginBottom: 2.5
                  }}>
                    <Typography variant="subtitle1" html>{t("nw.exit.detail.title.waiting_for_verified")}</Typography>
                  </Grid>
                </>}
                {!tempUser.exit_information?.itsme && <>
                  {!!tempUser.exit_information?.docs_uploaded && <>
                    <Grid item xs={12} sx={{marginTop: 4, position: 'relative',
                      marginBottom: 2.5
                    }}>
                      <Typography variant="subtitle1" html>{t("nw.exit.detail.title.waiting_for_verified")}</Typography>
                    </Grid>
                  </>}
                  {!tempUser.exit_information?.docs_uploaded && <>
                    <Grid item xs={12} sx={{
                      marginBottom: 2.5
                    }}>
                      <Typography html fuck_p_tags>{t("nw.exit.detail.title.upload_item_intro")}</Typography>
                    </Grid>
                    {(tempUser.exit_information?.blank || 'missing.png').indexOf("missing.png") < 0 && <Grid item xs={12} sx={{marginTop: -3, marginBottom: 2.5}}>
                      <DarkGreenButton
                        label={t("nw.exit.detail.detail.cta.blank_document").replace(/<[^>]*>?/gm, '')}
                        sx={{marginTop: 1}}
                        id="borderel"
                        onClick={(e) => {
                          window.open(tempUser.exit_information?.blank, '_BLANK');
                        }}
                      />
                    </Grid>}
                    <Grid item xs={12} sx={{
                      marginBottom: 2.5
                    }}>
                      <Typography html fuck_p_tags>{t("nw.exit.detail.title.upload_item_extra")}</Typography>
                    </Grid>
                    <Grid item xs={12} sx={{marginTop: 4, position: 'relative',
                      marginBottom: 2.5
                    }}>
                      <Typography variant="h2">{t("nw.exit.detail.title.upload_item")}</Typography>
                    </Grid>
                    <Grid item xs={12} sx={{
                      display: {
                        xs: 'none', md: 'flex'
                      },
                      "& .cust_dropzonearea > div > div": {
                        flexBasis: 'auto !important',
                        marginLeft: 'auto',
                        marginRight: 'auto'
                      },
                      marginBottom: 2.5
                    }}>
                      <DropzoneArea
                        acceptedFiles={['image/gif', 'image/jpeg', 'image/png', '.pdf']}
                        filesLimit={1}
                        fileObjects={[]}
                        dropzoneText={he.decode(t('nw.general.dropzone_text').replace(/<[^>]*>?/gm, ''))}
                        getDropRejectMessage={(rejectedFile, x, y) => {
                          return he.decode(t("nw.general_error.dropzone.rejected", {name: rejectedFile.name}).replace(/<[^>]*>?/gm, ''));
                        }}
                        onChange={(ff) => {
                          setFiles({
                            ...files,
                            item: ff[0]
                          });
                        }}
                        maxFileSize={3000000}
                        previewGridProps={{item: {style: {maxWidth: '100%', flexBasis: '100%'}}}}
                        dropzoneClass="cust_dropzonearea"
                      />
                    </Grid>
                    <Grid item xs={12} sx={{
                      display: {
                        xs: 'flex', md: 'none'
                      },
                      "& .cust_dropzonearea > div > div": {
                        flexBasis: 'auto !important',
                        marginLeft: 'auto',
                        marginRight: 'auto'
                      },
                      marginBottom: 2.5
                    }}>
                      <DropzoneArea
                        acceptedFiles={['image/gif', 'image/jpeg', 'image/png', '.pdf']}
                        filesLimit={1}
                        fileObjects={[]}
                        dropzoneText={he.decode(t('nw.general.dropzone_text_mobile').replace(/<[^>]*>?/gm, ''))}
                        getDropRejectMessage={(rejectedFile, x, y) => {
                          return he.decode(t("nw.general_error.dropzone.rejected", {name: rejectedFile.name}).replace(/<[^>]*>?/gm, ''));
                        }}
                        onChange={(ff) => {
                          setFiles({
                            ...files,
                            item: ff[0]
                          });
                        }}
                        maxFileSize={3000000}
                        previewGridProps={{item: {style: {maxWidth: '100%', flexBasis: '100%'}}}}
                        dropzoneClass="cust_dropzonearea"
                      />
                    </Grid>
                    <Grid item xs={12} sx={{marginTop: 4, position: 'relative',
                      marginBottom: 2.5
                    }}>
                      {!tempUser.exit_information?.guardian && <Typography variant="h2">{t("nw.exit.detail.title.upload_identity")}</Typography>}
                      {tempUser.exit_information?.guardian && <Typography variant="h2">{t("nw.exit.detail.title.upload_identity_guardian")}</Typography>}
                    </Grid>
                    <Grid item xs={12} sx={{
                      display: {
                        xs: 'none', md: 'flex'
                      },
                      "& .cust_dropzonearea > div > div": {
                        flexBasis: 'auto !important',
                        marginLeft: 'auto',
                        marginRight: 'auto'
                      },
                      marginBottom: 2.5
                    }}>
                      <DropzoneArea
                        acceptedFiles={['image/gif', 'image/jpeg', 'image/png', '.pdf']}
                        filesLimit={1}
                        fileObjects={[]}
                        dropzoneText={he.decode(t('nw.general.dropzone_text').replace(/<[^>]*>?/gm, ''))}
                        getDropRejectMessage={(rejectedFile, x, y) => {
                          return he.decode(t("nw.general_error.dropzone.rejected", {name: rejectedFile.name}).replace(/<[^>]*>?/gm, ''));
                        }}
                        onChange={(ff) => {
                          setFiles({
                            ...files,
                            identity: ff[0]
                          });
                        }}
                        maxFileSize={3000000}
                        previewGridProps={{item: {style: {maxWidth: '100%', flexBasis: '100%'}}}}
                        dropzoneClass="cust_dropzonearea"
                      />
                    </Grid>
                    <Grid item xs={12} sx={{
                      display: {
                        xs: 'flex', md: 'none'
                      },
                      "& .cust_dropzonearea > div > div": {
                        flexBasis: 'auto !important',
                        marginLeft: 'auto',
                        marginRight: 'auto'
                      },
                      marginBottom: 2.5
                    }}>
                      <DropzoneArea
                        acceptedFiles={['image/gif', 'image/jpeg', 'image/png', '.pdf']}
                        filesLimit={1}
                        fileObjects={[]}
                        dropzoneText={he.decode(t('nw.general.dropzone_text_mobile').replace(/<[^>]*>?/gm, ''))}
                        getDropRejectMessage={(rejectedFile, x, y) => {
                          return he.decode(t("nw.general_error.dropzone.rejected", {name: rejectedFile.name}).replace(/<[^>]*>?/gm, ''));
                        }}
                        onChange={(ff) => {
                          setFiles({
                            ...files,
                            identity: ff[0]
                          });
                        }}
                        maxFileSize={3000000}
                        previewGridProps={{item: {style: {maxWidth: '100%', flexBasis: '100%'}}}}
                        dropzoneClass="cust_dropzonearea"
                      />
                    </Grid>
                    <Grid item xs={12} sx={{textAlign: 'left'}}>
                      {!!files.item && <CheckCircleOutlineIcon sx={{marginRight: 2, marginBottom: -1, color: theme.palette.primary.light}} />}
                      {!files.item && <ErrorOutlineIcon sx={{marginRight: 2, marginBottom: -1, color: theme.palette.warning.main}} />}
                      <Typography variant="subtitle1" sx={{
                        marginTop: 1,
                        display: 'inline-block',
                        color: !files.item ? theme.palette.warning.main : theme.palette.primary.light,
                      }}>{t("nw.exit.detail.title.upload_item")}</Typography>
                    </Grid>
                    <Grid item xs={12} sx={{textAlign: 'left'}}>
                      {!!files.identity && <CheckCircleOutlineIcon sx={{marginRight: 2, marginBottom: -1, color: theme.palette.primary.light}} />}
                      {!files.identity && <ErrorOutlineIcon sx={{marginRight: 2, marginBottom: -1, color: theme.palette.warning.main}} />}
                      {!tempUser.exit_information?.guardian && <Typography variant="subtitle1" sx={{
                        marginTop: 1,
                        display: 'inline-block',
                        color: !files.identity ? theme.palette.warning.main : theme.palette.primary.light,
                      }}>{t("nw.exit.detail.title.upload_identity")}</Typography>}
                      {tempUser.exit_information?.guardian && <Typography variant="subtitle1" sx={{
                        marginTop: 1,
                        display: 'inline-block',
                        color: !files.identity ? theme.palette.warning.main : theme.palette.primary.light,
                      }}>{t("nw.exit.detail.title.upload_identity_guardian")}</Typography>}
                    </Grid>
                    <Grid item xs={12} sx={{marginTop: 4,
                      marginBottom: 2.5
                    }}>
                      <DarkGreenButton
                        disabled={!files.item || !files.identity || mutationCustomAction.isPending}
                        loading={mutationCustomAction.isPending}
                        onClick={(e) => {
                          const ob = {
                            object: 'user',
                            class_action: 'custom_api_exit_process',
                            id: tempUser?.id,
                            mode: 'upload_docs'
                          };
                          const formData = new FormData();
                          Object.keys(ob).forEach(key => {
                            // @ts-ignore
                            formData.append(key, ob[key]);
                          });
                          formData.append('item', files.item || '');
                          formData.append('identity', files.identity || '');

                          mutationCustomAction.mutate({
                            formData: formData,
                            mode: 'upload_docs'
                            });
                        }}
                        id="upload_docs"
                        label={t("nw.exit.detail.cta.upload_files")}
                        sx={{
                          color: 'white',
                          "&.Mui-disabled": {
                            color: 'white',
                          }
                        }}
                      />
                    </Grid>
                  </>}
                  {tempUser.exit_information?.checked > 0 && <>
                    <Grid item xs={12} sx={{marginTop: 4, position: 'relative',
                      marginBottom: 2.5
                    }}>
                      <Typography variant="subtitle1" html>{t("nw.exit.detail.title.waiting_for_verified")}</Typography>
                    </Grid>
                  </>}
                </>}
              </>}
            </>}
          </>}
        </>}

      </Grid>
    </WhiteSection>
  </Page>;
}